import {makeAutoObservable} from "mobx";

export default class UserStore {
    constructor() {
        this._isAuth = false
        this._userData = {}
        this._isLoaded = false; // <-- новый флаг

        makeAutoObservable(this)
    }

    setIsAuth(bool) {
        this._isAuth = bool
    }

    setUserData(data) {
        this._userData = data
    }

    setIsLoaded(bool) {
        this._isLoaded = bool; // <-- метод для обновления флага
    }

    get isAuth() {
        return this._isAuth
    }

    get UserData() {
        return this._userData
    }

    get isLoaded() {
        return this._isLoaded; // <-- геттер для проверки загрузки
    }
}